<!-- 特典を探す 中カテゴリ -->
<template>
  <li
    class="crly-m-common-search-category-middle"
    :class="{ 'no-children': !existChildrenList }"
  >
    <CrlyMoleculesCommonAccordion
      :contentsHeight="accordionContentsHeight"
      @clickToggle="clickToggle"
    >
      <template v-slot:label>
        <!-- ラベル -->
        <div
          class="crly-m-common-search-category-middle__title crly-link-icon"
          @click="clickMidCat"
        >
          <span>{{
            category.catSmNm ? category.catSmNm : category.catMidNm
          }}</span>
        </div>
      </template>
      <template v-slot:toggle>
        <!-- トグル 子カテゴリがない場合は非表示にする -->
        <div
          v-if="existChildrenList"
          class="crly-m-common-search-category-middle__toggle crly-toggle-icon"
          :class="{ open: isOpen }"
        ></div>
      </template>
      <template v-slot:contents>
        <!-- メインコンテンツ -->
        <ul
          class="crly-m-common-search-category-middle__contents"
          ref="content"
        >
          <template v-for="item in category.list">
            <CrlyAtomsCommonSearchCategorySmall
              :key="item.catSmCd"
              :category="item"
              :catType="catType ? catType : category.catType"
              :lrgCat="lrgCat"
              :midCat="category.catMidCd"
            />
          </template>
        </ul>
      </template>
    </CrlyMoleculesCommonAccordion>
  </li>
</template>

<script>
import CrlyMoleculesCommonAccordion from "@crly/components/molecules/common/Accordion.vue";
import CrlyAtomsCommonSearchCategorySmall from "@crly/components/atoms/common/search/category/Small.vue";

export default {
  name: "CrlyAtomsCommonSearchCategoryMiddle",
  components: {
    CrlyMoleculesCommonAccordion,
    CrlyAtomsCommonSearchCategorySmall
  },
  props: {
    category: {
      type: Object,
      default: () => ({})
    },
    /**
     * 特大カテゴリ
     */
    catType: {
      type: Number,
      default: null
    },
    /**
     * 大カテゴリ
     */
    lrgCat: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      /**
       * アコーディオン表示エリアの高さ
       */
      accordionContentsHeight: 0,
      isOpen: false
    };
  },
  computed: {
    /**
     * 子カテゴリがあるかどうか
     */
    existChildrenList() {
      if (this.category.list && this.category.list.length > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    /**
     * トグルのクリックイベント
     */
    clickToggle(status) {
      this.isOpen = status;
      this.$emit("clickCatSmToggle", status, this.listHeight);
      if (status) {
        this.calcContentHeight();
      }
      this.$emit("clickMidCatToggle", status, this.accordionContentsHeight);
    },
    /**
     * 表示エリアの高さを取得する
     */
    calcContentHeight() {
      const dom = this.$refs.content;
      const rect = dom.getBoundingClientRect();
      this.accordionContentsHeight = rect.height - 1;
    },
    /**
     * 遷移先URL作成
     */
    makeUrl(category) {
      let params = [];
      // グルメで中カテゴリが「飲食店」の場合
      if (this.lrgCat == "113" && category.catMidCd == "201") {
        //Type=2 のみ指定で検索
        params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=${category.catType}`);
        return this.makeSearchUrl(this.catType, params);
      }
      // 国内の宿以外
      if (this.lrgCat == "101" && category.catType) {
        params.push(`type=${category.catType}`);
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_LRG}=${this.lrgCat}`);
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_MID}=${category.catMidCd}`);
        if (category.catSmlCd) {
          params.push(
            `${this.CONST.SEARCH_PARAMS.CAT_SML}=${category.catSmlCd}`
          );
        }
        // 国内の宿以外は DP 検索になるので、こちらで設定した catType 値を入れている
        return this.makeSearchUrl("tour", params);
      }
      if (
        this.catType == this.CONST.CATEGORY_TYPE.LIFE ||
        this.catType == this.CONST.CATEGORY_TYPE.GOURMET
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=${this.catType}`);
      }
      params.push(`${this.CONST.SEARCH_PARAMS.CAT_LRG}=${this.lrgCat}`);
      params.push(`${this.CONST.SEARCH_PARAMS.CAT_MID}=${category.catMidCd}`);
      if (category.catSmlCd) {
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_SML}=${category.catSmlCd}`);
      }
      return this.makeSearchUrl(this.catType, params);
    },
    /**
     * 中カテゴリクリックイベント
     */
    clickMidCat() {
      const url = this.makeUrl(this.category);
      this.windowOpen(url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/category/middle.scss";
</style>
